export default "__VITE_ASSET__e5eea162__"